import styleManager from "./styleManager";

export default styleManager;